module.exports = __webpack_public_path__ + "img/imagen.ad3c05c8.png";